import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ProcessingDirective } from '@fantaz/shared/directives/processing';
import { SharedPipesDateModule } from '@fantaz/shared/pipes/date';
import { CurrencyModule } from '@fantaz/shared/ui/currency';
import { MaterialModule } from '@fantaz/shared/ui/material';
import { SubscriptionModule } from '@fantaz/shared/ui/subscribe';
import { TournamentControlsComponent } from './tournament-controls.component';

@NgModule({
  imports: [
    CommonModule,
    CurrencyModule,
    SubscriptionModule,
    MaterialModule,
    SharedPipesDateModule,
    ProcessingDirective,
  ],
  declarations: [TournamentControlsComponent],
  exports: [TournamentControlsComponent],
})
export class TournamentControlsModule {}
